export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7288.fe9b35f0.jpg";